import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { Wrapper } from './configure_banner.styles';

import useAccountPermission from '../../../hooks/useAccountPermission';
import useIsConfigured from '../../../hooks/useIsConfigured';

function ConfigureBannerContent() {
  const isConfigured = useIsConfigured();

  if (isConfigured) {
    return null;
  }

  return (
    <Wrapper>
      <p>
        <T>To enjoy all the benefits</T>
      </p>
      <Link to="/configure">
        <T>Finish configuration</T>
      </Link>
    </Wrapper>
  );
}

export default function ConfigureBanner() {
  const hasCardsModifyPermission = useAccountPermission('cards_modify');
  const hasPlacesModifyPermission = useAccountPermission('places_modify');

  const shouldDisplayBanner = hasCardsModifyPermission && hasPlacesModifyPermission;

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ConfigureBannerContent />
    </Suspense>
  );
}
